import { Icon } from "./Icon.tsx";

/** Raingage-group icon (ElementBrowser.tsx's own "Raingages" header) — a raindrop, matching SettingsMenu.tsx's own app logo motif rather than the plain circle NetworkMap.tsx draws a raingage as (a raindrop reads as "rain gauge" on sight; a lone circle wouldn't be distinguishable from NodeIcon.tsx's own). */
export function RaingageIcon() {
  return (
    <Icon>
      <path d="M12 3c3 4.5 6 8 6 11.5a6 6 0 0 1-12 0C6 11 9 7.5 12 3Z" />
    </Icon>
  );
}
